@if (parentFormGroup.controls[controlName]) {
  <div
    [formGroup]="parentFormGroup"
    class="wrapper"
    >
    @if (label) {
      <div [class.error]="error" class="label">{{ label }}@if (isRequired) {
        <span>*&nbsp;</span>
      }:</div>
    }
    <div class="button-panel flex flex-row flex-wrap justify-start items-center gap-[12px]">
      @for (option of options; track option) {
        <div
          (click)="isEditable ? select(option) : null"
          [class.selected]="parentFormGroup?.controls[controlName]?.value === option.type"
          class="button"
          >
          {{ option.label }}
        </div>
      }
    </div>
    @if (error) {
      <mat-error class="error">{{ error }}</mat-error>
    }
  </div>
}
